import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="mx-auto flex max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-primary-600">
        <i className="ri-compass-3-line text-3xl" />
      </span>
      <h1 className="mt-5 font-heading text-2xl font-black text-foreground-950 md:text-3xl">这个页面还没有内容</h1>
      <p className="mt-3 font-label text-sm text-foreground-500">路径：{location.pathname}</p>
      <p className="mt-2 max-w-md font-body text-sm leading-relaxed text-foreground-600">
        可能是链接已经失效，或者页面正在整理中。你可以回到首页，或者直接去避雷名单查一查。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-home-4-line text-base" />
          返回首页
        </Link>
        <Link
          to="/blacklist"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          <i className="ri-list-check-2 text-base" />
          浏览避雷名单
        </Link>
      </div>
    </section>
  );
}